"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _formgroup_compact_props = _interopRequireDefault(require("./formgroup_compact_props"));

var _formgroup_props = require("./formgroup_props");

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var FormGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FormGroup, _PureComponent);

  function FormGroup(props) {
    var _this;

    _classCallCheck(this, FormGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormGroup).call(this, props));
    _this.feedbackRef = null;
    _this.prefixRef = null;
    _this.formGroupRef = null;
    return _this;
  }

  _createClass(FormGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // 放到下一个 Event Loop 阶段再执行，防止首次渲染(ReactDOM.render)时导致获取到的计算宽度为0
      setTimeout(function () {
        _this2.setInputPaddingRight();
      }, 0);

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setInputPaddingRight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.feedbackRef = null;
      this.prefixRef = null;
      this.formGroupRef = null;
    }
  }, {
    key: "setInputPaddingRight",
    value: function setInputPaddingRight() {
      var _this$props = this.props,
          _this$props$autoFeedb = _this$props.autoFeedbackWidth,
          autoFeedbackWidth = _this$props$autoFeedb === void 0 ? true : _this$props$autoFeedb,
          _this$props$autoPrefi = _this$props.autoPrefixWidth,
          autoPrefixWidth = _this$props$autoPrefi === void 0 ? true : _this$props$autoPrefi;
      var feedbackSpace = parseInt(this.props.feedbackSpace, 10) || 0;
      var prefixSpace = parseInt(this.props.prefixSpace, 10) || 0;
      var feedbackRect = {};

      if (autoFeedbackWidth && this.feedbackRef && this.formGroupRef) {
        feedbackRect = this.feedbackRef.getBoundingClientRect();

        if (feedbackRect.width > 0) {
          this.formGroupRef.style.setProperty('--feedback-width', "".concat(parseInt(feedbackRect.width + feedbackSpace, 10), "px"));
        }
      }

      var prefixRect = {};

      if (autoPrefixWidth && this.prefixRef && this.formGroupRef) {
        prefixRect = this.prefixRef.getBoundingClientRect();

        if (prefixRect.width > 0) {
          this.formGroupRef.style.setProperty('--form-group-prefix-width', "".concat(parseInt(prefixRect.width + prefixSpace, 10), "px"));
        }
      }
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _this$props$className = this.props.classNameMap,
          classNameMap = _this$props$className === void 0 ? {} : _this$props$className;
      return _objectSpread({}, _classname_map["default"], {}, classNameMap);
    }
  }, {
    key: "getInputChildren",
    value: function getInputChildren() {
      var children = this.props.children;
      var result = [];

      if (children && children.length > 0) {
        children.map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (item) {
            var type = item.type;
            var componentName = '';

            if (typeof type === 'string' && type === 'input') {
              result.push(item);
            } else {
              if (typeof type !== 'undefined') {
                componentName = type.componentName || type.displayName || '';
              }

              if (item) {
                if (type && componentName === 'spaui-input') {
                  result.push(item);
                }
              }
            }
          }

          return item;
        });
      } else if (children && _typeof(children) === 'object') {
        var type = children.type;
        var componentName = '';

        if (typeof type === 'string' && type === 'input') {
          result.push(children);
        } else {
          if (typeof type !== 'undefined') {
            componentName = type.componentName || type.displayName || '';
          }

          if (type && componentName === 'spaui-input') {
            result.push(children);
          }
        }
      }

      return result;
    }
  }, {
    key: "getStatusAndHelpBlock",
    value: function getStatusAndHelpBlock() {
      var _this$props2 = this.props,
          success = _this$props2.success,
          error = _this$props2.error,
          status = _this$props2.status,
          helpBlock = _this$props2.helpBlock;
      var statusResult = '';
      var helpBlockResult = '';

      if (typeof success !== 'undefined' && success) {
        statusResult = 'success';
        helpBlockResult = success;
      } else if (typeof error !== 'undefined' && error) {
        statusResult = 'error';
        helpBlockResult = error;
      } else {
        statusResult = status;
        helpBlockResult = helpBlock;
      }

      return {
        status: statusResult,
        helpBlock: helpBlockResult
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          _this$props3$feedback = _this$props3.feedback,
          feedback = _this$props3$feedback === void 0 ? null : _this$props3$feedback,
          onClear = _this$props3.onClear,
          feedbackStyle = _this$props3.feedbackStyle,
          _this$props3$feedback2 = _this$props3.feedbackClassName,
          feedbackClassName = _this$props3$feedback2 === void 0 ? '' : _this$props3$feedback2,
          HelpBlockComponent = _this$props3.HelpBlockComponent,
          prefix = _this$props3.prefix;
      var htmlRef = this.props.htmlRef || this.props.htmlref;

      var _compactProps = (0, _formgroup_compact_props["default"])(this.props),
          clear = _compactProps.clear;

      var inputChildren = this.getInputChildren();

      var _this$getStatusAndHel = this.getStatusAndHelpBlock(),
          status = _this$getStatusAndHel.status,
          helpBlock = _this$getStatusAndHel.helpBlock;

      var _clear = inputChildren.length > 0 && inputChildren[0].props.value && clear;

      var classNameMap = this.getClassNameMap();
      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(classNameMap.bootstrapFormGroup, classNameMap.FormGroup, {
          'has-feedback': feedback || _clear,
          'has-prefix': prefix,
          'has-error': status === 'error',
          'has-success': status === 'success',
          'has-warning': status === 'warning',
          'has-helpblock': helpBlock,
          'spaui-input-feedback-clear': clear && feedback
        }),
        supportAllEvents: true
      }, FormGroup), {
        ref: function ref(el) {
          _this3.formGroupRef = el;

          if ((0, _spauiUtils.isFunction)(htmlRef)) {
            htmlRef(el);
          }
        }
      }), prefix ? _react["default"].createElement("div", {
        className: classNameMap.FormGroupPrefix,
        ref: function ref(el) {
          _this3.prefixRef = el;
        }
      }, prefix) : null, children, feedback || clear ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])('spaui-input-feedback', feedbackClassName, {
          'only-clear': clear && !feedback
        }),
        style: feedbackStyle,
        ref: function ref(el) {
          _this3.feedbackRef = el;
        }
      }, clear ? _react["default"].createElement("div", {
        className: "spaui-input-clear",
        role: "button",
        onClick: onClear
      }, _react["default"].createElement("svg", {
        viewBox: "0 0 16 16",
        width: "16px",
        height: "16px"
      }, _react["default"].createElement("circle", {
        fill: "currentColor",
        fillRule: "evenodd",
        cx: "8",
        cy: "8",
        r: "8"
      }), _react["default"].createElement("path", {
        d: "M5.333 5.333l5.334 5.334M10.667 5.333l-5.334 5.334",
        stroke: "#FFF",
        strokeLinecap: "square"
      }))) : null, feedback) : null, helpBlock && typeof HelpBlockComponent !== 'undefined' ? _react["default"].createElement(HelpBlockComponent, this.props, helpBlock) : null);
    }
  }]);

  return FormGroup;
}(_react.PureComponent); // 组件标记


_defineProperty(FormGroup, "propTypes", _formgroup_props.propTypes);

_defineProperty(FormGroup, "defaultProps", _formgroup_props.defaultProps);

(0, _spauiUtils.setComponentMark)(FormGroup, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = FormGroup;
exports["default"] = _default;